// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZrXQ","newExpiryDate":"styles_newExpiryDate__2CRGM","footer":"styles_footer__YozO4"};